import type { CameraRig } from '../render/CameraRig';

// Camera shake was disabled per player request: landing a punch used to add
// camera trauma (screen shake) + a FOV impulse. With four characters in the
// arena these fired from every NPC-on-NPC impact too, producing a constant
// low-grade jolt whenever fighting went on offscreen. `punch()` is now a
// no-op; `reset()` still clears the CameraRig in case other code calls it.
export class ScreenShake {
  constructor(private rig: CameraRig) {}
  punch(_strength: number): void { /* no-op — shake disabled */ }
  reset(): void { this.rig.reset(); }
}
